import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SessionLayer from "../components/SessionLayer";


const SessionPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Sessions" />

        {/* ViewProfileLayer */}
        <SessionLayer />

      </MasterLayout>

    </>
  );
};

export default SessionPage; 
